// Import dependencies
import { initialiser } from '../../ramen-imports/utilitybelt';
import { addClasses, removeClasses } from '../../utils';

const defaultSettings = {
  menuOpenClass: 'is-open',
  menuOpenClassBody: 'has-menu-open',
  subnavContentOpenClass: 'is-active',
};

class Navigation {
  constructor(config) {
    const { el, settings } = config;

    // Set root element
    this.nav = el;
    this.navItems = [...el.querySelectorAll(settings.navItems)];
    this.navBtns = [...el.querySelectorAll(settings.navBtns)];
    this.subnavWrapper = settings.subnavWrapper;
    this.subnavWrapperList = [...el.querySelectorAll(settings.subnavWrapper)];
    this.subnavItems = [...el.querySelectorAll(settings.subnavItems)];
    this.subnavContentWrapper = settings.subnavContentWrapper;
    this.subnavContentWrapperList = [...el.querySelectorAll(settings.subnavContentWrapper)];
    this.subnavItemsContentEles = settings.subnavItemsContentEles;
    this.subnavItemsContentElesList = [...el.querySelectorAll(settings.subnavItemsContentEles)];
    this.subnavBackBtns = [...el.querySelectorAll(settings.subnavBackBtns)];
    this.searchWrapper = el.querySelector(settings.searchWrapper);
    this.searchBtns = [...el.querySelectorAll(settings.searchBtns)];
    this.searchBackBtn = el.querySelector(settings.searchBackBtn);

    // Set settings
    this.settings = { ...defaultSettings, ...settings };
  }

  // Initialisation Function - Called on each component instance intialisation
  init = () => {
    if (!this.nav || !this.navBtns.length || !this.subnavWrapperList.length) return;

    // Call bind events
    this.bindEvents();
  };

  bindEvents = () => {
    this.navBtns.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        this.handleNavToggle(e);
      });
    });

    this.subnavBackBtns.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        this.handleNavToggle(e);
      });
    });

    this.subnavItems.forEach((subnavItem) => {
      subnavItem.addEventListener('mouseover', (e) => this.handleSubNavToggle(e));
    });

    this.searchBtns.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        this.handleSearchToggle(e);
      });
    });

    this.searchBackBtn.addEventListener('click', (e) => {
      this.handleSearchToggle(e, true);
    });
  };

  handleSubNavToggle = (e) => {
    const currentSubnavBtn = e.currentTarget;
    const currentSubnavContentId = currentSubnavBtn.dataset.subnavId;
    const currentSubnavContentEle = this.nav.querySelector(`#${currentSubnavContentId}`);
    const currentSubnavWrapperId = currentSubnavBtn.parentElement.id.split('-list')[0];
    const currentSubnavWrapper = this.nav.querySelector(`#${currentSubnavWrapperId}`);
    const currentSubnavContentList = [...currentSubnavWrapper.querySelectorAll(this.subnavItemsContentEles)];

    // Hide and show secondary nav's content
    currentSubnavContentList.forEach((contentEle) => {
      if (contentEle === currentSubnavContentEle) {
        contentEle.style.display = 'block'; // eslint-disable-line
        addClasses(contentEle, this.settings.subnavContentOpenClass);
        return;
      }

      removeClasses(contentEle, this.settings.subnavContentOpenClass);

      // Hide element once the animation on the element is complete
      setTimeout(() => {
        contentEle.style.display = 'none'; // eslint-disable-line
      }, 600);
    });
  };

  handleSearchToggle = (e, remove = false) => {
    e.preventDefault();

    // Highlight search buttons
    this.navBtns.forEach((el) => removeClasses(el, this.settings.menuOpenClass));
    if (remove) this.searchBtns.forEach((el) => el.classList.remove(this.settings.menuOpenClass));
    else this.searchBtns.forEach((el) => el.classList.toggle(this.settings.menuOpenClass));

    // Show and hide search wrapper
    this.subnavWrapperList.forEach((el) => removeClasses(el, this.settings.menuOpenClass));
    if (remove) this.searchWrapper.classList.remove(this.settings.menuOpenClass);
    else this.searchWrapper.classList.toggle(this.settings.menuOpenClass);

    this.toggleParentClass();
  };

  handleNavToggle = (e) => {
    e.preventDefault();

    const currentNavBtn = e.currentTarget;
    const currentNavBtnParent = currentNavBtn.parentElement;
    const currentSubnavWrapper = currentNavBtnParent.querySelector(this.subnavWrapper);

    // Highlight active button in main navbar
    this.highlightActiveElement(this.navBtns, currentNavBtn, this.settings.menuOpenClass);

    // Hide search
    this.searchWrapper.classList.remove(this.settings.menuOpenClass);
    // Show and hide subnav wrapper
    this.highlightActiveElement(this.subnavWrapperList, currentSubnavWrapper, this.settings.menuOpenClass);

    this.toggleParentClass();

    // Ser first content element active by default
    setTimeout(() => {
      this.setFirstContentEleActive(this.settings.subnavContentOpenClass);
    }, 600);
  };

  highlightActiveElement = (eleList, activeEle, activeClass) => {
    eleList.forEach((ele) => {
      if (ele === activeEle) {
        ele.classList.toggle(activeClass);
        return;
      }

      removeClasses(ele, activeClass);
    });
  };

  setFirstContentEleActive = (activeClass) => {
    this.subnavContentWrapperList.forEach((wrapper) => {
      const subnavContentEles = [...wrapper.querySelectorAll(this.subnavItemsContentEles)];

      subnavContentEles.forEach((contentEle, index) => {
        if (index === 0) {
          addClasses(contentEle, activeClass);
          return;
        }

        contentEle.classList.remove(activeClass); // eslint-disable-line
        contentEle.style.display = 'none'; // eslint-disable-line
      });
    });
  };

  toggleParentClass = () => {
    const activeNav = this.navBtns.find((btn) => btn.classList.contains(this.settings.menuOpenClass));

    // Delay adding body locked class to prevent page content jump left to right when
    // scrollbar disappears for overflow: hidden
    if (activeNav) {
      setTimeout(() => {
        document.body.classList.add(this.settings.menuOpenClassBody);
      }, 800);
      this.nav.classList.add(this.settings.menuOpenClass);
    } else {
      document.body.classList.remove(this.settings.menuOpenClassBody);
      this.nav.classList.remove(this.settings.menuOpenClass);
    }
  };
}

// Export component wrapped in initialiser utility
export default (settings) => initialiser(settings, Navigation);
